import {Component, inject} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {TranslateModule} from "@ngx-translate/core";
import {MatDialogRef} from "@angular/material/dialog";
import {EventService} from "shared/event.service";

@Component({
    selector: 'app-freemium-premium-reverse-trial',
    imports: [
        MatIconModule,
        TranslateModule,
    ],
    templateUrl: './freemium-premium-reverse-trial.component.html'
})
export class FreemiumPremiumReverseTrialComponent {
    private eventService = inject(EventService);
    dialogRef = inject(MatDialogRef<FreemiumPremiumReverseTrialComponent>);

    action(userWantToBuyPremiumAccess: boolean) {
        if (userWantToBuyPremiumAccess){
            this.eventService.trackEvent('click button', 'start trial period', 'premium');
        } else {
            this.eventService.trackEvent('click button', 'dismiss trial period', 'premium');
        }
        this.dialogRef.close(userWantToBuyPremiumAccess);
    }
}
